import { CONNECTION_STATE } from '@/shared/const/ws';

export default {
  computed: {
    connectionState() {
      return this.$store.getters['state/WS']?.connectionState;
    },

    connectionMsg() {
      switch (this.connectionState) {
        case CONNECTION_STATE.CONNECTING.code:
          return {
            text: 'Переподключение...',
            class: 'grey--text'
          };

        case CONNECTION_STATE.CLOSED.code:
          return {
            text: 'Соединение с сервером потеряно. Пожалуйста, обновите страницу.',
            class: 'error--text'
          };

        default:
          return null;
      }
    },

    connectionIcon() {
      switch (this.connectionState) {
        case CONNECTION_STATE.CLOSED.code:
          return {
            text: 'close',
            color: 'red'
          };

        default:
          return null;
      }
    },

    connectionLoading() {
      return [CONNECTION_STATE.CONNECTING.code].includes(this.connectionState);
    },

    isView() {
      return [
        CONNECTION_STATE.CONNECTING.code,
        CONNECTION_STATE.CLOSED.code
      ].includes(this.connectionState);
    }
  }
};
